import { CarOutlined, ShopOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { PreHeaderTranscription } from 'config/constants/transcription.constant';
import React from 'react';
import styles from './style.module.scss';
import { WHATSAPP_API_HREF } from 'config/constants/api.constants';

export type PreHeaderItem = {
  key: string;
  icon: React.ReactNode;
  label: string;
  href?: string;
  ariaLabel?: string;
};

const PRE_HEADER_ITEMS: PreHeaderItem[] = [
  {
    key: 'shipping',
    icon: <CarOutlined />,
    label: PreHeaderTranscription.SHIPPING,
  },
  {
    key: 'pickup',
    icon: <ShopOutlined />,
    label: PreHeaderTranscription.PICKUP,
  },
  {
    key: 'whatsapp',
    icon: <WhatsAppOutlined />,
    label: PreHeaderTranscription.WHATSAPP,
    href: WHATSAPP_API_HREF,
    ariaLabel: PreHeaderTranscription.WHATSAPP_ARIA,
  },
];

const renderItemContent = (item: PreHeaderItem): React.ReactNode => (
  <React.Fragment>
    <span className={styles['icon']} aria-hidden>
      {item.icon}
    </span>
    <span>{item.label}</span>
  </React.Fragment>
);

const renderItem = (item: PreHeaderItem): React.ReactNode => (
  <li key={item.key} className={styles['item']}>
    {item.href ?
      <a className={styles['link']} href={item.href} target='_blank' rel='noopener noreferrer' aria-label={item.ariaLabel}>
        {renderItemContent(item)}
      </a>
    : renderItemContent(item)}
  </li>
);

const PreHeader: React.FC = () => {
  return (
    <div className={styles['preHeader']} role='region' aria-label={PreHeaderTranscription.REGION_LABEL}>
      <ul className={styles['list']}>{PRE_HEADER_ITEMS.map(renderItem)}</ul>
    </div>
  );
};

export default PreHeader;
